module.exports = __webpack_public_path__ + "CreativeDirection38.jpg?cdb36c35e530b61ca2920be182ee9650";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection38.jpg
// module id = 51
// module chunks = 0